import {useIntl} from 'react-intl';

import {Image} from '@time-webkit/all/atoms/image';
import {EarthIcon} from '@time-webkit/all/icons/earth';
import {DropdownListItem} from '@time-webkit/all/organisms/dropdown';
import type {Country} from '@time-webkit/all/utils/phone-codes/constants';

import styles from './styles.module.css';

type RowProps = {
    index: number;
    style: React.CSSProperties;
    data: {
        handleCountryClick: (country: Country) => void;
        finalCountries: Country[];
    };
}

export const Row = ({index, style, data}: RowProps) => {
    const {formatMessage} = useIntl();
    const item = data.finalCountries[index]!;

    return (
        <DropdownListItem
            key={item.countryCode}
            style={style}
            label={formatMessage({
                id: `countries.name.${item.countryCode}`,
                defaultMessage: item.translations.en,
            })}
            onClick={() => data.handleCountryClick(item)}
            className={styles.dropdown_item}
            textRight={'+' + item?.countryCallingCode}
            icon={
                <div className={styles.flag_container}>
                    <Image
                        src={item?.image}
                        width='21'
                        height='15'
                        alt='flag'
                        placeholder={
                            <EarthIcon
                                width={16}
                                height={16}
                                className={styles.earth}
                            />
                        }
                        fallback={
                            <EarthIcon
                                width={16}
                                height={16}
                                className={styles.earth}
                            />
                        }
                    />
                </div>
            }
        />
    );
};
